export const SERVICE_DESK_ISSUE_CONTAINER_NAME = 'SERVICE_DESK_ISSUE_CONTAINER_NAME' as const;
export const PROJECT_ISSUE_CONTAINER_NAME = 'PROJECT_ISSUE_CONTAINER_NAME' as const;

export type IssueContainerName =
	| typeof SERVICE_DESK_ISSUE_CONTAINER_NAME
	| typeof PROJECT_ISSUE_CONTAINER_NAME;
